"use client";

import { Avatar, styled } from "@mui/material";

export const SkillLogo = styled(Avatar)({
  width: 26,
  height: 26,
  img: {
    objectFit: "contain",
  },
});